import styled from 'styled-components';

export const Container = styled.div`
  margin: 15px;
`;

export const Header = styled.div`
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.p`
  color: #000;
  font-size: 20px;
`;

export const UploadPdfForm = styled.div`
  display: flex;
  grid-gap: 15px;
  height: 40px;

  button {
    background-color: #000;
    color: #fff;
    width: 450px;
    text-transform: capitalize;
    box-shadow: none;
    :hover {
      background-color: #000;
      color: #fff;
    }
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  min-height: 700px;
  margin: 20px 0;
`;

export const StyledForm = styled.div``;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 49% 49%;
  gap: 2%;
`;

export const StyledPdfViewer = styled.div`
  iframe {
    width: 100%;
    height: 50%;
    border: 0;
    margin-bottom: 20px;
  }
`;

export const SubTitle = styled.div`
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const Order = styled.div``;

export const Card = styled.div`
  border: 1px solid #ccc;
  padding: 40px 10px 10px 10px;
  border-radius: 10px;
  box-shadow: 3px -1px 20px -10px rgb(0 0 0 / 75%);
  margin-bottom: 10px;
`;

export const FieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  margin-top: 20px;
  border-bottom: 1px solid #a1a1a1;
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const ProductFieldWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 10px;
`;

export const PrintAreasFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr auto;
  grid-gap: 10px;
  margin-top: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  align-items: center;
  svg {
    color: red;
    cursor: pointer;
  }
`;

export const ReceivedQtyFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  margin-top: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  align-items: center;
  button {
    color: white;
    background: black;
    box-shadow: none;
  }
`;

export const StaplesShippedDate = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  margin-top: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  align-items: center;
`;

export const Label = styled.h3`
  font-size: 13px;
  margin: 0;
  line-height: 24px;
  background-color: ${(props) =>
    props?.showBackgroundColor ? 'green' : 'inherit'};
  color: ${(props) => (props?.showBackgroundColor ? 'white' : 'inherit')};
  padding: ${(props) => (props?.showBackgroundColor ? '5px' : 0)};
  border-radius: ${(props) => (props?.showBackgroundColor ? '5px' : 0)};
  margin-top: ${(props) => (props?.showBackgroundColor ? '5px' : 0)};
`;

export const FromHeaderTitle = styled.h1`
  font-size: 20px;
  color: black;
  margin: 0;
`;

export const SubTitleWrapper = styled.div``;

export const SubTitle1 = styled.h1`
  margin: 0;
  color: black;
  font-size: 19px;
  line-height: 30px;
`;
export const SubTitle2 = styled.h3`
  margin: 0;
  color: #676a6c;
  font-size: 14px;
  line-height: 20px;
`;

export const FormHeader = styled.div`
  border-bottom: 1px solid #ccc;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 15px;
  button {
    color: #fff;
    background: #000;
    font-size: 14px;
    padding: 0px 16px;

    :disabled {
      opacity: 0.7;
    }
    :hover {
      color: #fff;
      background: #000;
    }
  }
`;

export const SimpleCard = styled.div`
  padding-bottom: 20px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
`;

export const AdditionalInformationTitle = styled.h3`
  margin-top: 0;
  color: black;
`;

export const Error = styled.h4`
  margin: 10px 0 0;
  color: red;
`;

export const PrintAreasWrapper = styled.div``;
export const PrintAreasHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  h3 {
    color: #000;
    margin: 0;
  }
  svg {
    cursor: pointer;
    color: #000;
  }
`;

export const CloudinaryWrapper = styled.div`
  position: relative;
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.26);
  border-radius: 5px;
  input {
    padding-left: 0;
    padding-right: 40px;
  }
  img {
    width: 50px;
    padding: 5px;
    cursor: pointer;
  }

  label {
    background: #f3f3f4;
    padding: 0 10px;
  }
  fieldset {
    border: none;
  }
  svg {
    position: absolute;
    right: 6px;
    top: 6px;
    color: #337894;
    cursor: pointer;
  }
`;

export const PaginationWrapper = styled.div`
  margin: 20px 0 0;
  display: flex;
  justify-content: flex-end;
`;

export const ProductModalFilter = styled.div`
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ProductModalFields = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 10px;
`;

export const ButtonWrapper = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  button {
    width: 100%;
    padding: 10px;
  }
`;

export const SearchWrapper = styled.div`
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin-left: 20px;
    height: 40px;
  }
`;
